<template lang="pug">
  div.vkb_nak.vkb_nak_fsoel.vkb_nak_index_app
    div.small-12.medium-12.large-9.columns.wrapper-spacing
      div.extended-progress.extended-progress-standard.extended-progress-tabs-6
        ul
          li(:class="date_range === 1 ? 'active' : 'inactive'" @click="onSelectDateRange(1)")
            span.extended-progress-numb 1
            span.extended-progress-desc Monat
            span.extended-progress-short-desc M

          li(:class="date_range === 2 ? 'active' : 'inactive'" @click="onSelectDateRange(2)")
            span.extended-progress-numb 6
            span.extended-progress-desc Monate
            span.extended-progress-short-desc M

          li(:class="date_range === 3 ? 'active' : 'inactive'" @click="onSelectDateRange(3)")
            span.extended-progress-numb 1
            span.extended-progress-desc Jahr
            span.extended-progress-short-desc J

          li(:class="date_range === 4 ? 'active' : 'inactive'" @click="onSelectDateRange(4)")
            span.extended-progress-numb 3
            span.extended-progress-desc Jahr
            span.extended-progress-short-desc J

          li(:class="date_range === 5 ? 'active' : 'inactive'" @click="onSelectDateRange(5)")
            span.extended-progress-numb 5
            span.extended-progress-desc Jahr
            span.extended-progress-short-desc J

          li(:class="date_range === 6 ? 'active' : 'inactive'" @click="onSelectDateRange(6)")
            span.extended-progress-numb S
            span.extended-progress-desc eit Auflage
            span.extended-progress-short-desc Max

      div.row.wrapper-spacing
        div.columns.small-12
          h4 Zeitraum
          label.filter-input
            div.filter-input__date-from
              span.date-from von
              vkb-date-picker(
                ref="date-from"
                v-model="date_from"
                format="DD.MM.YYYY"
                :max-date="max_date"
                :min-date="min_date"
                :invalid="$v.date_from.$invalid"
                @show="closeOtherPicker('date-to')"
              )
              div.hint-wrapper(v-if="$v.$invalid && $v.$dirty")
                div.hint.error.open(v-if="!$v.date_from.max")
                  p Das Maximales Datum ist {{ max_date }}
                div.hint.error.open(v-else-if="!$v.date_from.min")
                  p Das Mindestdatum ist {{ min_date }}

            div.filter-input__date-to
              span.date-to bis
              vkb-date-picker(
                ref="date-to"
                v-model="date_to"
                format="DD.MM.YYYY"
                :max-date="max_date"
                :min-date="min_date"
                :invalid="$v.date_to.$invalid"
                @show="closeOtherPicker('date-from')"
              )
              i.fo.fo-exclamation.info-tooltip.ml-2.mt-1
                span.hint technisch bedingt werden nur Kurswerte des letzten Werktages/Börsentages angezeigt

              div.hint-wrapper(v-if="$v.$invalid && $v.$dirty")
                div.hint.error.open(v-if="!$v.date_to.valid")
                  p Bitte geben Sie ein Datum an
                div.hint.error.open(v-else-if="!$v.date_to.max")
                  p Das Maximales Datum ist {{ max_date }}
                div.hint.error.open(v-else-if="!$v.date_to.min")
                  p Das Mindestdatum ist {{ min_date }}

            div.filter-input__button
              a.button(href="#" @click.prevent="loadResult(false)")
                i.fo.fo-arrow-right
                span Anzeigen

      div.row
        div.columns.small-12
          noa-chart(:data="chart_data" app="fsoel" :min="chartMin" :max="chartMax")

      div.row
        div.columns.small-12.medium-12.large-12.noa-summary-wrapper
          div.noa-summary
            span.noa-summary__label Aktueller Kurs:
            span.noa-summary__value {{ formatValue(summary_data.aktueller_kurs) }} EURO

          div.noa-summary
            span.noa-summary__label Wertentwicklung

          div.noa-summary
            span.noa-summary__label.left-padded im betrachteten Zeitraum:
            span.noa-summary__value {{ formatValue(summary_data.betrachteter_zeitraum) }} %

          div.noa-summary
            span.noa-summary__label.left-padded seit Jahresbeginn: x{{indexName}}y
            span.noa-summary__value(v-if="currentYear === 2025 && indexName === 'VK_MSCI_World'") n/a
            span.noa-summary__value(v-else) {{ formatValue(summary_data.Wertentwicklung_jahr) }} %

          div.noa-summary
            span.noa-summary__label Stand:
            span.noa-summary__value {{ formatDate(summary_data.stand) }}

          div.noa-summary
            span.noa-summary__label Auflagedatum:
            span.noa-summary__value {{ formatDate(summary_data.auflagedatum) }}


      .row.mt-5
        .d-flex.align-center.mt-5.columns
          label.mb-3 Kurswerte im Detail anzeigen
          n-radio.ml-3(
            v-model="showTable"
            :options="radioOptions"
          )

      div.row(v-if="table_data && table_data.length && showTable")
        vkb-data-table.my-6(
          :headers="headers"
          :items="table_data"
        )
          span.h2-line-height(slot="header.date") Datum
          span.h2(slot="header.value") Kurswert

          span(slot="item.date" slot-scope="{ item }") {{ formatDate(item.date) }}
          span(slot="item.value" slot-scope="{ item }") {{ formatValue(item.value) }}

</template>

<script>
import logic from './logic.js';

export default {
  name: 'index-app-fsoel',

  mixins: [
    logic
  ],
};
</script>



// WEBPACK FOOTER //
// src/apps/index_app/fsoel.vue